module.exports = __webpack_public_path__ + "img/tire-pressure-warning.7e0686cc.svg";